import { Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import type { AdminRole } from '@monigo/shared';
import { useSession } from '../../lib/store/session.js';
import { LoadingScreen } from '../Status/LoadingScreen.js';

interface RequireAdminProps {
  children: ReactNode;
  allow?: AdminRole[];
}

export function RequireAdmin({ children, allow }: RequireAdminProps) {
  const { user, role, loading } = useSession();
  const location = useLocation();
  if (loading) return <LoadingScreen />;
  if (!user) return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  if (!role) return <Navigate to="/login" replace />;
  if (allow && !allow.includes(role)) return <Navigate to="/" replace />;
  return <>{children}</>;
}
